import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { useState } from "react";

const CopyUrlButton = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy URL", err);
    }
  };

  return (
    <div className="w-100 d-flex flex-row align-items-center justify-content-center h-100 my-2">
      <Button
        onClick={handleCopyUrl}
        title="Copy URL"
        className={`w-50  ${copied ? "bg-success text-white" : "bg-primary"}`}
        size="sm"
        variant="primary"
        style={{ width: "93px", height: "36px", fontSize: "0.9rem" }}
      >
        <span className="me-1">{copied ? "Copied" : "Copy URL"}</span>
        <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
      </Button>
    </div>
  );
};

export default CopyUrlButton;
